
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassador-application",
      function () {
        return require("private-next-pages/ambassador-application.js");
      }
    ]);
  